import { cs, MuiImage, useIsDesktop } from "@repo/ui";
import novelBannerImage from "@repo/ui/assets/images/novel-banner.png";
import { type FC } from "react";
import * as Styled from "./PensionNovelBanner.styled";

type PensionNovelBannerProps = {
    onButtonClick: () => void;
};

export const PensionNovelBanner: FC<PensionNovelBannerProps> = ({ onButtonClick }) => {
    const isDesktop = useIsDesktop();

    return (
        <Styled.BannerWrapper>
            {isDesktop && (
                <Styled.ImageContainer>
                    <MuiImage src={novelBannerImage} alt="Novel banner" />
                </Styled.ImageContainer>
            )}
            <Styled.ContentContainer>
                <Styled.HeadingContainer>
                    {cs.pensionNovel.text1} <Styled.HighlightedText>{cs.pensionNovel.text1b}</Styled.HighlightedText>
                    <Styled.InlineText>{cs.pensionNovel.text1c}</Styled.InlineText>
                </Styled.HeadingContainer>
            </Styled.ContentContainer>

            <Styled.ButtonContainer spacing={3}>
                <Styled.StyledButton onClick={onButtonClick}>{cs.pensionNovel.getMoreInfo}</Styled.StyledButton>
            </Styled.ButtonContainer>
        </Styled.BannerWrapper>
    );
};

export default PensionNovelBanner;
